/* Gift Box Builder — shared helpers. Loads before tcgb.js. */
window.TCGB=(function(){
var GIFT=/gift box/i,BOWL=/bowl|loose[-_ ]?leaf/i,JAR=/jar|pouch/i,PRE=/^pre[-_ ]?order$/i;
function m(c){return '$'+(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',')}
function e(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){
return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
function sz(u,w){return u?u.replace(/(\.(?:jpe?g|png|webp|gif))(\?.*)?$/i,'_'+w+'x$1$2'):''}
function get(h){return fetch('/collections/'+h+'/products.json?limit=250',{headers:{Accept:'application/json'}})
.then(function(r){return r.ok?r.json():{products:[]}}).catch(function(){return{products:[]}})}
function look(id,cb){if(!id)return;fetch('/variants/'+id+'.js')
.then(function(r){return r.ok?r.json():null}).then(function(v){if(v)cb(v)}).catch(function(){})}
function pic(p,v){if(v&&v.featured_image&&v.featured_image.src)return v.featured_image.src;
return p.images&&p.images.length?p.images[0].src:''}
function lb(t){if(!t||t==='Default Title')return '';
if(/tea bags?/i.test(t))return 'Tea bags';
if(/bath soak/i.test(t))return 'Bath soak';
var g=t.match(/(\d+\s*g)\b/i);return g?'Loose leaf '+g[1]:t}
/* Is this product on pre-order? Driven by the same "preorder" tag the
   product page uses, so the two can never disagree. */
function isPre(p){var t=p.tags||[],i;
if(typeof t==='string')t=t.split(',');
for(i=0;i<t.length;i++){if(PRE.test(String(t[i]).trim()))return true}
return false}
/* Picture for the Learn-more pop-up: prefer a shot of the loose tea itself. */
function hero(p){var im=p.images||[],i,s,a;
for(i=0;i<im.length;i++){s=im[i].src||'';a=im[i].alt||'';
if((BOWL.test(s)||BOWL.test(a))&&!JAR.test(s))return im[i].src}
for(i=0;i<im.length;i++){s=im[i].src||'';if(!JAR.test(s))return im[i].src}
return im.length?im[0].src:''}
/* Build a product list from /products.json payloads.
   jarsOnly: keep only variants whose name starts with "Boutique Jar". */
function coll(ps,jo){var by={};
ps.forEach(function(D){(D.products||[]).forEach(function(p){(p.variants||[]).forEach(function(v){
if(!v.available)return;
if(jo&&String(v.title).indexOf('Boutique Jar')!==0)return;
if(!by[p.id])by[p.id]={id:p.id,title:p.title,type:p.product_type||'Other',img:pic(p,v),
img2:hero(p),desc:p.body_html||'',pre:isPre(p),o:[]};
by[p.id].o.push({id:v.id,label:lb(v.title),raw:v.title,price:Math.round(parseFloat(v.price)*100)})})})});
return Object.keys(by).map(function(k){return by[k]})
.sort(function(a,b){return a.title.localeCompare(b.title)})}
return {GIFT:GIFT,m:m,e:e,sz:sz,get:get,look:look,coll:coll,hero:hero,isPre:isPre};
})();